import React from "react";

// Admin Imports
import Profile from "components/Javascript_profile/profile.js";
import CreateChurchTable from "components/WidgetChurch/CreateChurchTable";
import MainChurchComponent from "components/MainChurchComponent/MainChurchComponent";
import ChurchMembers from "components/WidgetChurch/ChurchMembers";
import PastorVerification from "components/PastorVerification/PastorVerification";

// Auth Imports
import SignIn from "views/auth/SignIn";

import { MdHome, MdPerson, MdPeople, MdVerifiedUser } from "react-icons/md";

const routes = [
  {
    name: "Main Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainChurchComponent />,
  },
  {
    name: "Profile",
    layout: "/admin",
    path: "profile",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Profile />,
  },
  {
    name: "Church",
    layout: "/admin",
    path: "church",
    icon: <MdHome className="h-6 w-6" />,
    component: <CreateChurchTable />,
  },
  {
    name: "Church Members",
    layout: "/admin",
    path: "church-members",
    icon: <MdPeople className="h-6 w-6" />,
    component: <ChurchMembers />,
  },
  {
    name: "Pastor Verification",
    layout: "/admin",
    path: "pastor-verification",
    icon: <MdVerifiedUser className="h-6 w-6" />,
    component: <PastorVerification />,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdPerson className="h-6 w-6" />,
    component: <SignIn />,
  },
];
export default routes;
